<template>
    <section class="rules">
        <div class="text">
            <h2>{{ config.BRIEF_RULES_TITLE }}</h2>
            <p>{{ config.BRIEF_RULES_DESCRIPTION }}</p>
        </div>
        <BriefRuleset type="do" :title="config.BRIEF_RULES_DO" :rules="rules"/>
        <BriefRuleset type="dont" :title="config.BRIEF_RULES_DONT" :rules="rules"/>
        <div class="actions">
            <slot/>
        </div>
    </section>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import { BriefRuleset } from '../../components/shared';

export default {
    name: 'BriefRules',
    components: { BriefRuleset },
    mixins: [SolutionConsumer],
    props: {
        rules: {
            type: Array,
            required: true,
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

section {
    @include brief-section-grid();

    > .text {
        text-align: center;
    }

    > .actions {
        justify-self: center;
    }

    @include breakpoint-min(lg) {
        > .text {
            grid-column: 1 / 3;
        }

        > .actions {
            grid-column: 1 / 3;
        }
    }
}
</style>
